"use strict";
window.addEventListener("hashchange", function() {
    if (window.location.hash === "#menu") document.body.classList.add("page__body--with-menu");
    else document.body.classList.remove("page__body--with-menu");
});
document.addEventListener("DOMContentLoaded", function() {
    var slides = document.querySelectorAll(".materials__slide");
    var buttons = document.querySelectorAll(".materials__icons-button");
    function showSlide(index) {
        slides.forEach(function(slide, i) {
            if (i === index) slide.style.display = "block";
            else slide.style.display = "none";
        });
        buttons.forEach(function(button) {
            button.classList.remove("materials__icons-button--active");
        });
        buttons[index].classList.add("materials__icons-button--active");
    }
    showSlide(0);
    buttons.forEach(function(button, index) {
        button.addEventListener("click", function() {
            return showSlide(index);
        });
    });
});
var myButtons = document.querySelectorAll(".materials__button-img");
myButtons.forEach(function(button) {
    button.addEventListener("click", function() {
        var contentClass = button.dataset.contentClass;
        if (button.classList.contains("materials__button-img--active")) {
            button.classList.remove("materials__button-img--active");
            document.querySelector(".".concat(contentClass)).style.display = "none";
        } else {
            myButtons.forEach(function(btn) {
                btn.classList.remove("materials__button-img--active");
                var btnContentClass = btn.dataset.contentClass;
                document.querySelector(".".concat(btnContentClass)).style.display = "none";
            });
            button.classList.add("materials__button-img--active");
            document.querySelector(".".concat(contentClass)).style.display = "block";
        }
    });
});
var form = document.getElementById("form");
var userName = document.getElementById("user-name");
var userEmail = document.getElementById("user-email");
var userMessage = document.getElementById("user-message");
form.addEventListener("submit", function(event) {
    event.preventDefault();
    userName.value = "";
    userEmail.value = "";
    userMessage.value = "";
    validateInput(userName);
    validateInput(userEmail);
    validateInput(userMessage);
    document.getElementById("form").classList.add("footer__form--success");
});
userName.addEventListener("input", function() {
    return validateInput(userName);
});
userEmail.addEventListener("input", function() {
    return validateInput(userEmail);
});
userMessage.addEventListener("input", function() {
    return validateInput(userMessage);
});
function validateInput(inputElement) {
    if (inputElement.checkValidity()) inputElement.classList.remove("error");
    else inputElement.classList.add("error");
}

//# sourceMappingURL=index.86483abf.js.map
